
import { defineComponent, PropType } from "vue";
import { TypePaymentMethod, useBillStore, TypeBanks } from "@/stores/BillStore";
import { mapActions, mapState } from "pinia";

export default defineComponent({
  data: () => ({
    slide: 0,
  }),

  computed: {
    ...mapState(useBillStore, ["paymentTypes", "waitPayment"]),
  },

  methods: {
    ...mapActions(useBillStore, ["payment"]),
  },

  props: {
    bank: {
      type: String as PropType<TypeBanks>,
      required: true,
    },
    paymentMethod: {
      type: String as PropType<TypePaymentMethod>,
      required: true,
    },
  },
});
